import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import drugSearchAnalyticService from '../../../services/drug-search-analytics.service';

const MostActiveDrugSearchUsers = ({ filters }) => {
  const [mostActiveUsers, setMostActiveUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMostActiveUsersData = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await drugSearchAnalyticService.getMostActiveDrugSearchUsers({
            ...filters,
          });

        setMostActiveUsers(data?.most_active_users);
      } catch (err) {
        console.error('Error fetching most active users', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchMostActiveUsersData();
  }, [filters]);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }
  if (error)
    return (
      <div className="text-danger">Failed to load most active users data.</div>
    );

  if (mostActiveUsers.length === 0) {
    return (
      <div className="text-muted text-center fw-semibold">
        No data available for most active users.
      </div>
    );
  }

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        barHeight: '45%',
        horizontal: true,
        distributed: true,
      },
    },
    colors: [
      '#4c1d95',
      '#6d28d9',
      '#7c3aed',
      '#8b5cf6',
      '#a855f7',
      '#d946ef',
      '#ec4899',
      '#f43f5e',
      '#fb7185',
      '#f97316',
    ],
    dataLabels: { enabled: false },
    xaxis: {
      categories: mostActiveUsers.map((user) => user.name),
      labels: {
        style: {
          colors: '#6b7280',
          fontSize: '12px',
        },
        rotate: -45,
      },
      forceNiceScale: true,
    },
    yaxis: {
      labels: { style: { colors: '#6b7280' } },
    },
    tooltip: {
      followCursor: true,
      y: { formatter: (val) => `${val}` },
    },
    grid: {
      borderColor: '#e5e7eb',
      strokeDashArray: 4,
    },
  };

  const series = [
    {
      name: 'Searches',
      data: mostActiveUsers.map((user) => user.search_count),
    },
  ];

  return <Chart options={options} series={series} type="bar" height={350} />;
};

export default MostActiveDrugSearchUsers;
